import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';

import Navbar from '../../molecules/Navbar/Navbar';
import MainContent from '../../molecules/MainContent/MainContent';
import Footer from '../../molecules/Footer/Progressive/Footer';

import './Progressive.scss';

function Progressive() {
  return (
    <div id="pageWrapper">
      <Suspense>
        <BrowserRouter>
          <Navbar />
          <MainContent />
          <Footer />
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default Progressive;
